
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In der Schweiz herrscht im Sommer oft eine trockene Hitze, die Verdunstung der
Bäume an die Luft wird dadurch verstärkt. Haben diese zu wenig Wassernachschub
aus dem Boden, können sie sich nicht mehr kühlen und werden beschädigt.
Geschwächte Bäume wiederum sind empfindlicher für äussere Einflüsse wie Stürme
oder Schädlinge.`}</p>
    <p>{`«Wir hatten massive Borkenkäferschäden dieses und auch schon letztes Jahr», sagt
Gessler. Er erwartet, dass beispielsweise die Mortalität bei Fichten zunehmen
wird, die von den Käfern mit Vorliebe befallen werden. Heisse Sommer und warme
Winter tragen das ihrige dazu bei. Auch Buchen sind an gewissen Standorten
gefährdet und es wird wegen des Klimawandels immer mehr solche Standorte geben.
Zudem wird laut Gessler das Absterben der Föhre langfristig zunehmen, vor allem
in niederen Lagen wie dem Rhonetal im Wallis.`}</p>
    <blockquote>
      <div class='quote'>
  «Wenn wir wieder einen Hitzesommer erleben, dann gibt es grosse Schäden.»
      </div>
      <div class='credits'>Arthur Gessler, Ökologe</div>
    </blockquote>
    <p>{`Oft wird oft beobachtet, dass die eigentliche Mortalität erst im ersten und
zweiten Folgejahr sichtbar wird. Und die letzten drei Sommer waren alle
Jahrhundert­ereignisse (hier geht es zu unserer Auswertung:
`}<a parentName="p" {...{
        "href": "https://interaktiv.tagesanzeiger.ch/2019/so-war-der-sommer/"
      }}>{`156 Schweizer Sommer im Vergleich`}</a>{`).
Die Auswirkungen davon dürften heuer zu spüren sein. Wegen der Verringerung des
Wassergehalts färbten sich beispielsweise viele Buchenwälder braun und sind
heute noch stark beschädigt.`}</p>
    <p>{`Sollte es dieses Jahr wieder trocken bleiben, würde sich die Situation weiter
zuspitzen. «Wenn wir wieder einen Hitzesommer erleben, dann gibt es grosse
Schäden», warnt Gessler und verweist besorgt auf die bisherigen Prognosen. Die
`}<a parentName="p" {...{
        "href": "https://public.wmo.int/en/media/news/global-partnership-urges-stronger-preparation-hot-weather-during-covid-19"
      }}>{`Weltwetterorganisation (WMO)`}</a>{`
rechnet 2020 mit einer «Rekord-Hitzesaison» auf der Nordhalbkugel. Noch ist
diese in der Schweiz nicht eingetroffen. Aber das war auch 2018 so, das am
Schluss als heisses und trockenes Jahr zahlreiche Rekorde brach. Der
Saisonausblick von
`}<a parentName="p" {...{
        "href": "https://www.meteoschweiz.admin.ch/home/wetter/prognosen/saisonausblick.html?filters=CHS_2020_jja"
      }}>{`Meteo Schweiz`}</a>{`,
also die Vorhersage der Temperaturtendenz für die nächsten drei Monate, lässt
erahnen, dass sich auch bei uns wieder ein überdurchschnittlich warmer Sommer
ankündigt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;